import React, { useState, useEffect } from "react";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
  Row,
  Col,
  Container,
  Card,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import { useSelector } from "react-redux";
import classnames from "classnames";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import {
  STATE_LIST,
  UPDATE_END_USER,
  UPLOAD_FILE,
} from "../../../constants/ApiPaths";
import * as Yup from "yup";
import { useSnackbar } from "notistack";
import {
  PAY_PUP_ADMIN_PROFILE_IMAGE,
  PAY_PUP_LS_AUTH_USER_DETAILS,
} from "../../../constants/LocalStorageVariables";
import CustomButtonLoader from "../../CustomComponents/CustomButtonLoader";
import API from "../../../redux/actions/API";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import {
  authCustomerHeader,
} from "../../../functions/CoreFunctions";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import { getLoggedUserDetails } from "../../../redux/actions";
import {
  getCustomerUserId,
} from "../../common/CommonFunctions";
import UserChangePassword from "./UserhangePassword";
import userlogo from "../../../images/user logo.png";
import { NUMBER_REGEX } from "../../../constants/ValidationRegex";
function UserSettings() {
  const dispatch = useDispatch();
  const [imageLoading, setImageLoading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    profileImage: "",
    gender: "",
    dateOfBirth: "",
    address: "",
    city: "",
    zip: "",
    stateName: "",
  });
  const reduxState = useSelector((state) => state.AuthUserDetailsReducer);
  const DeleteAgency = useSelector((state) => state.Agencydelete);

  useEffect(() => {
    const {
      firstName,
      lastName,
      email,
      phoneNumber,
      gender,
      dateOfBirth,
      address,
      city,
      zip,
      stateName,
      profileImage = "",
    } = reduxState;

    setFormData({
      firstName: firstName,
      lastName: lastName,
      email: email,
      phoneNumber: phoneNumber,
      profileImage: profileImage,
      gender: gender,
      dateOfBirth: dateOfBirth,
      address: address,
      city: city,
      zip: zip,
      stateName: stateName,
    });
  }, [reduxState]);
  const [activeTab, setActiveTab] = useState("1");
  const { enqueueSnackbar } = useSnackbar();
  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const [loading, setLoading] = useState(false);
  const [selectState, setSelectState] = useState([]);
  Yup.addMethod(Yup.string, "phoneNumberValidation", function (errorMessage) {
    return this.test(`test-card-type`, errorMessage, function (value) {
      const { path, createError } = this;
      if (value) {
        let v1 = value;
        if (value.includes("+1 ")) {
          v1 = value.split("+1 ")[1];
        } else {
          // Handle the case where "+1 " is not present
          v1 = value;
        }

        var num = v1.replace(/\D+/g, "");
        var check = v1.match(/[A-Za-z_@./#&+!^*+=,:;]/) ? false : true;
        let Pass = num.length <= 10;
        return (check && Pass) || createError({ path, message: errorMessage });
      } else {
        return createError({ path, message: "Phone Number is Required" });
      }
    });
  });
  const TEN_DIGIT_PHONE_NUMBER_REGEX = /^\d{10}$/;
  const validationSchema = Yup.object({
    firstName: Yup.string().trim().required("First Name is required"),
    lastName: Yup.string().trim().required("Last Name is required"),
    // phoneNumber: Yup.string().phoneNumberValidation("Invalid Phone Number"),
    phoneNumber: Yup.string()
      .trim()
      .required("Phone number is required")
      .matches(TEN_DIGIT_PHONE_NUMBER_REGEX, "Enter valid phone number"),
    // gender: Yup.string().required("Gender is required"),
    // dateOfBirth: Yup.date()
    //   .max(new Date(), "Invalid Date")
    //   .required("Date Of Birth Required"),
    address: Yup.string().required("Address is required"),
    city: Yup.string().required("City is required"),
    zip: Yup.string()
      .matches(NUMBER_REGEX, "Zip Code must be Number")
      .required("Zip is required"),
  });

  useEffect(() => {
     const getStateList = async () => {
       const config = {
         method: "Get",
         url: STATE_LIST,
         data: formData,
         headers: authCustomerHeader(),
       };
       try {
         const response = await API(config);
         const { status, data } = response.data;
         if (status === "Success") {
           setSelectState(data);
         }
       } catch (error) {
         console.error(error);
       } finally {
       }
     };
    getStateList();
  }, []);

  //get State list
 
  const saveFormValues = async (values) => {
    if (DeleteAgency) {
      return;
    }
    const userId = getCustomerUserId();

    setLoading(true);
    const config = {
      method: "PUT",
      url: UPDATE_END_USER,
      data: { ...values, userId: userId },
      headers: authCustomerHeader(),
    };

    try {
      const response = await API(config);
      const { status } = response.data;

      if (status === "Success") {
        CustomAlertMessage(
          "Profile Updated Successfully!",
          "success",
          enqueueSnackbar
        );
        localStorage.setItem(
          PAY_PUP_LS_AUTH_USER_DETAILS,
          JSON.stringify(values)
        );
        dispatch(getLoggedUserDetails(userId));
      }
    } catch (error) {
      let { data } = error.response;

      CustomAlertMessage(data.message, "error", enqueueSnackbar);
    } finally {
      setLoading(false);
    }
  };
  //Formik
  const {
    handleSubmit,
    handleChange,
    values,
    errors,
    setValues,
    touched,
    handleBlur,
  } = useFormik({
    initialValues: formData,
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => saveFormValues(values),
  });
  const choosenImage = async (event) => {
    const file = new FormData();
    file.append("file", event.target.files[0]);
    if (!event.target.files[0]) return;
    setImageLoading(true);
    const config = {
      method: "POST",
      url: UPLOAD_FILE,
      headers: authCustomerHeader(),
      data: file,
      "content-type": "multipart/form-data",
    };

    try {
      const response = await API(config);
      const { filepath, status } = response.data;
      if (status === "Success") {
        setValues({
          ...values,
          profileImage: filepath,
        });
        localStorage.setItem(PAY_PUP_ADMIN_PROFILE_IMAGE, filepath);
      }
    } catch (error) {
      console.error(error);
      let { data } = error.response;

      CustomAlertMessage(data.message, "error", enqueueSnackbar);
    } finally {
      setImageLoading(false);
    }
  };
  console.log(values, "PROFLE");
  return (
    <div>
      <div>
        <Container fluid>
          <Card body>
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "1" })}
                  onClick={() => {
                    toggle("1");
                  }}
                >
                  General
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: activeTab === "2" })}
                  onClick={() => {
                    toggle("2");
                  }}
                >
                  Security
                </NavLink>
              </NavItem>
            </Nav>

            <TabContent activeTab={activeTab} className="mt-lg-5">
              <TabPane tabId="1">
                <Form form="true" onSubmit={handleSubmit}>
                  <div className="page">
                    <Row>
                      <Col md="3" className="user-setting-box">
                        {imageLoading && <CustomPageLoading />}

                        <img
                          src={
                            values.profileImage ? values.profileImage : userlogo
                          }
                          alt=""
                        />
                      </Col>
                      <Col md="5" className="user-edit">
                        <p>Edit Profile Picture</p>
                        <span>
                          PNG or JPG no bigger than 1000px wide and tall
                        </span>
                      </Col>
                      <Col md="4">
                        <label
                          for="files"
                          style={{
                            float: "right",
                            width: "120px",
                            height: "35px",
                            backgroundColor: "#1b3e6f",
                            color: "white",
                            textAlign: "center",
                            paddingTop: "5px",
                            borderRadius: "0.25rem",
                            cursor: "pointer",
                          }}
                        >
                          Upload{" "}
                        </label>
                        <input
                          className="w-100"
                          type="file"
                          name="profileImage"
                          id="files"
                          accept=".png, .jpg"
                          onChange={choosenImage}
                          style={{ visibility: "hidden" }}
                          values={values.profileImage}
                        />
                      </Col>
                    </Row>
                    <Row className="user-settings-form">
                      <Col md="5">
                        <FormGroup>
                          <Label for="">First Name</Label>
                          <Input
                            type="text"
                            name="firstName"
                            id="firstName"
                            placeholder="Enter First Name"
                            value={values.firstName}
                            invalid={
                              errors.firstName && touched.firstName
                                ? true
                                : false
                            }
                            onChange={handleChange}
                          />
                          <FormFeedback>
                            {errors.firstName && touched.firstName
                              ? errors.firstName
                              : ""}
                          </FormFeedback>
                        </FormGroup>

                        <FormGroup>
                          <Label for="">Email</Label>
                          <Input
                            type="text"
                            name="email"
                            id="email"
                            value={values.email}
                            onBlur={handleBlur}
                            invalid={
                              errors.email && touched.email ? true : false
                            }
                            onChange={handleChange}
                            placeholder="Enter Email "
                            disabled={true}
                          />
                          <FormFeedback>
                            {errors.email && touched.email ? errors.email : ""}
                          </FormFeedback>
                        </FormGroup>
                        {/* <FormGroup>
                          <Label for="">Gender</Label>
                          <Input
                            type="select"
                            name="gender"
                            id="gender"
                            value={values.gender}
                            onBlur={handleBlur}
                            invalid={
                              errors.gender && touched.gender ? true : false
                            }
                            onChange={handleChange}
                            placeholder="Enter Gender "
                          >
                            <option value="">Select Gender</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                          </Input>
                          <FormFeedback>
                            {errors.gender && touched.gender
                              ? errors.gender
                              : ""}
                          </FormFeedback>
                        </FormGroup> */}
                        <FormGroup>
                          <Label for="">Address</Label>
                          <Input
                            type="text"
                            name="address"
                            id="address"
                            value={values.address}
                            onBlur={handleBlur}
                            invalid={
                              errors.address && touched.address ? true : false
                            }
                            onChange={handleChange}
                            placeholder="Enter Address "
                          />
                          <FormFeedback>
                            {errors.address && touched.address
                              ? errors.address
                              : ""}
                          </FormFeedback>
                        </FormGroup>
                        {/* state */}
                        <FormGroup>
                          <Label for="state">State</Label>
                          <Input
                            type="select"
                            name="stateId"
                            value={values.stateId}
                            onBlur={handleBlur}
                            invalid={
                              touched.stateId && errors.stateId ? true : false
                            }
                            onChange={handleChange}
                            id="state"
                            placeholder="Enter state name"
                          >
                            <option value="">
                              {values.stateName
                                ? values.stateName
                                : "Select State"}
                            </option>
                            {selectState.map((data) => {
                              const { stateId, stateName } = data;
                              return (
                                <option value={stateId}>{stateName}</option>
                              );
                            })}
                          </Input>
                          <FormFeedback>
                            {touched.stateId && errors.stateId}
                          </FormFeedback>
                        </FormGroup>
                      </Col>

                      <Col md="5">
                        <FormGroup>
                          <Label for="">Last Name</Label>
                          <Input
                            type="text"
                            name="lastName"
                            id="lastName"
                            value={values.lastName}
                            onBlur={handleBlur}
                            invalid={
                              errors.lastName && touched.lastName ? true : false
                            }
                            onChange={handleChange}
                            placeholder="Enter Last Name"
                          />
                          <FormFeedback>
                            {errors.lastName && touched.lastName
                              ? errors.lastName
                              : ""}
                          </FormFeedback>
                        </FormGroup>
                        <FormGroup>
                          <Label for="">Phone Number</Label>
                          <Input
                            type="text"
                            name="phoneNumber"
                            id="phoneNumber"
                            placeholder="Enter  Phone Number"
                            value={values.phoneNumber}
                            onBlur={handleBlur}
                            invalid={
                              errors.phoneNumber && touched.phoneNumber
                                ? true
                                : false
                            }
                            onChange={handleChange}
                          />
                          <FormFeedback>
                            {errors.phoneNumber && touched.phoneNumber
                              ? errors.phoneNumber
                              : ""}
                          </FormFeedback>
                        </FormGroup>
                        {/* <FormGroup>
                          <Label for="">DOB</Label>
                          <Input
                            type="date"
                            name="dateOfBirth"
                            id="dateOfBirth"
                            value={moment(
                              values.dateOfBirth == "01/01/1900"
                                ? ""
                                : values.dateOfBirth
                            ).format("YYYY-MM-DD")}
                            invalid={
                              errors.dateOfBirth && touched.dateOfBirth
                                ? true
                                : false
                            }
                            onChange={handleChange}
                            placeholder="Enter DOB "
                          />
                          <FormFeedback>
                            {errors.dateOfBirth && touched.dateOfBirth
                              ? errors.dateOfBirth
                              : ""}
                          </FormFeedback>
                        </FormGroup> */}
                        <FormGroup>
                          <Label for="">City</Label>
                          <Input
                            type="text"
                            name="city"
                            id="city"
                            value={values.city}
                            onBlur={handleBlur}
                            invalid={errors.city && touched.city ? true : false}
                            onChange={handleChange}
                            placeholder="Enter City "
                          />
                          <FormFeedback>
                            {errors.city && touched.city ? errors.city : ""}
                          </FormFeedback>
                        </FormGroup>
                        <FormGroup>
                          <Label for="">Zip</Label>
                          <Input
                            type="text"
                            name="zip"
                            id="zip"
                            value={values.zip}
                            onBlur={handleBlur}
                            invalid={errors.zip && touched.zip ? true : false}
                            onChange={handleChange}
                            placeholder="Enter Zip "
                          />
                          <FormFeedback>
                            {errors.zip && touched.zip ? errors.zip : ""}
                          </FormFeedback>
                        </FormGroup>

                        {/* Button */}

                        <Button
                          type="submit"
                          color="primary"
                          className="user-top-btn d-block ml-auto"
                        >
                          {loading && <CustomButtonLoader loading={loading} />}
                          Save Changes
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </Form>
              </TabPane>
              <TabPane tabId="2">
                <UserChangePassword />
              </TabPane>
            </TabContent>
          </Card>
        </Container>
      </div>
    </div>
  );
}

export default UserSettings;
